var getBuiltIn = require('../internals/get-built-in');

module.exports = getBuiltIn('document', 'documentElement');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/internals/html.js
// module id = 216
// module chunks = 48